import React from 'react';
import { useSelector } from 'react-redux';
import * as Icon from 'react-feather';
import { pageMapping } from '../../../apps/regionalAnalysis/vars/pageMapping';

const ApplyFiltersButton = () => {
  const mapSelection = useSelector((state) => state.filters.mapSelection);

  const onClickHandler = () => {
    // handle on click
    // usually this will mean: applying some state variables

    const pagePath = '/analysen/regionalanalyse/' + pageMapping[mapSelection.value];

    window.location.pathname = pagePath;
  };

  return (
    <button
      type="button"
      className="useFilter"
      onClick={onClickHandler}
      disabled={mapSelection?.value <= 0}
    >
      <Icon.Filter className="feather" />
      Filter anwenden
    </button>
  );
};

export default ApplyFiltersButton;
